/*
 * ログインお知らせメール用に、ブラウザ名と実バージョンを解決する。
 *
 * Chrome / Edge 等は User-Agent Reduction により UA 文字列上の版が
 * 「150.0.0.0」のように固定されるため、User-Agent Client Hints の
 * fullVersionList から実バージョンを取得する。
 * Client Hints 非対応ブラウザでは undefined を返し、サーバ側の UA 解析に任せる。
 */

const BRAND_ALIASES = {
	'Google Chrome': 'Chrome',
	'Microsoft Edge': 'Edge',
};

const PREFERRED_BRAND = /Google Chrome|Microsoft Edge|Opera|Firefox|Safari/i;
const GREASE_BRAND = /Not.?A.?Brand/i;

/**
 * @returns {Promise<string|undefined>} 例: "Chrome 150.0.7871.47"。取得できない場合は undefined
 */
export async function resolveDeviceLabel() {
	try {
		if (!navigator.userAgentData?.getHighEntropyValues) {
			return undefined;
		}

		const { fullVersionList } = await navigator.userAgentData.getHighEntropyValues([
			'fullVersionList',
		]);

		if (!Array.isArray(fullVersionList) || fullVersionList.length === 0) {
			return undefined;
		}

		const preferred =
			fullVersionList.find((b) => PREFERRED_BRAND.test(b.brand)) ||
			fullVersionList.find(
				(b) => !GREASE_BRAND.test(b.brand) && !/^Chromium$/i.test(b.brand)
			) ||
			fullVersionList.find((b) => !GREASE_BRAND.test(b.brand));

		if (!preferred?.brand || !preferred?.version) {
			return undefined;
		}

		const name = BRAND_ALIASES[preferred.brand] || preferred.brand;
		return `${name} ${preferred.version}`;
	} catch (error) {
		console.warn('Failed to resolve browser version via Client Hints:', error);
		return undefined;
	}
}
